/**
 * @returns {boolean}
 */
export default function isTouchDevice() {
  const prefixes = ['', '-webkit-', '-moz-', '-o-', '-ms-'];
  const mq = query => window.matchMedia(query).matches;

  if (
    // eslint-disable-next-line
    'ontouchstart' in window
    // eslint-disable-next-line
      || (window.DocumentTouch && document instanceof DocumentTouch)
  ) {
    return true;
  }

  // include the 'heartz' as a way to have a non matching MQ to help terminate the join
  // https://git.io/vznFH
  const myquery = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join(
    ''
  );
  return mq(myquery);
}
